(function () {
    const modal  = document.querySelector('#js-special-checkin-modal');
    if (!modal) return;

    const DISMISSED_KEY = 'sci-modal-dismissed';

    if (localStorage.getItem(DISMISSED_KEY)) return;

    modal.hidden = false;

    const yesBtn = document.querySelector('#js-special-checkin-yes');
    const noBtn  = document.querySelector('#js-special-checkin-no');

    noBtn?.addEventListener('click', () => {
        localStorage.setItem(DISMISSED_KEY, '1');
        modal.hidden = true;
    });

    yesBtn?.addEventListener('click', async () => {
        yesBtn.disabled = true;
        try {
            await fetch(yesBtn.dataset.url, { method: 'POST' });
        } finally {
            modal.hidden = true;
        }
    });
})();
